// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cc43e8d5","455":"ded023a8"}[chunkId] + ".chunk.js";
};